<div class="modal modal--md">
  <div class="modal__header">
    <div class="grid-row grid-row--aic">
      <div class="grid-col">
        <div class="h3">Disable AutoPay</div>
      </div>
      <div class="grid-col grid-col--auto">
        <button (click)="dialogRef.close()" type="button" class="modal__close"><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
      </div>
    </div>
  </div>
  <div class="modal__cont">

    <div *ngIf="didDeleteError$ | async" class="alert alert--error">
      Attempt to disable has failed, please try your request again later.
    </div>

    <div>
      Your AutoPay settings for {{ data.account }} will be deleted and future invoices will have to be paid manually. However, you can always set up an AutoPay again using one of your saved payment methods.
    </div>

    <div class="mt--125 grid-row grid-row--jcb">
      <div class="button-row">
        <button
          andButton
          (click)="cancel()"
          type="button"
        >
          Cancel
        </button>
        <button
          andButton
          color="primary"
          (click)="disable()"
          [disabled]="isDeleteProcessing$ | async"
        >
          <ng-container *ngIf="isDeleteProcessing$ | async; else disabling">
            Disabling...
          </ng-container>
          <ng-template #disabling>
            Disable
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</div>
